import * as service from './service'
export default {
  namespace: 'levelSysFullLevel',
  state: {
    fullLevel: []
  },
  effects: {
    * fullLevel ({ payload }, { call, put }) {
      const res = yield call(service.fullLevel, payload)
      yield put({
        type: 'save',
        payload: {
          fullLevel: res.data.data.levelConf
        }
      })
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
